<template>
  <b-container fluid>
    <b-row>
      <b-col 
        v-if="unit !== null" 
        cols="3"
      >
        <b-overlay 
          :show="busy" 
          variant="dark"
        >
          <b-card no-body>
            <b-card-header>
              <b-card-title>Logboek</b-card-title>
              <b-card-sub-title>{{ unitLogBoekPath }}</b-card-sub-title>
            </b-card-header>
            <b-card-body>
              <b-form-group>
                <b-input
                  v-model="nieuwbericht.subject"
                  placeholder="Nieuw bericht..."
                />
                <b-textarea
                  v-model="nieuwbericht.message"
                  placeholder="Bericht..."
                  rows="3"
                />
              </b-form-group>
              <b-row>
                <b-col>
                  <b-button
                    class="pull-right mb-4"
                    variant="primary"
                    @click="postMessage"
                  >
                    Plaats bericht
                  </b-button>
                </b-col>
              </b-row>

              <b-card
                v-for="(item, index) in berichten"
                :key="index"
                bg-variant="secondary"
              >
                <b-card-text>
                  <b>{{ item.Naam }}</b> op
                  <b>{{ moment(item.GemaaktOp).format("LLL") }}</b>
                </b-card-text>
                <b-container>
                  <i>{{ item.Body }}</i>
                </b-container>
                <b-button
                  size="sm"
                  class="pull-right"
                  variant="warning"
                  @click="deleteMessage(item)"
                >
                  verwijderen
                </b-button>
              </b-card>
            </b-card-body>
          </b-card>
        </b-overlay>
      </b-col>
      <b-col cols="5">
        <b-card no-body>
          <b-card-header>
            <b-card-title>Storingen</b-card-title>
          </b-card-header>
          <b-card-body>
            <b-list-group>
              <b-list-group-item
                v-for="(item, index) in unit.StoringenLaatsteJaren.filter(item => item.Aantal > -1)"
                :key="index"
              >
                <b-input-group>
                  <b-input
                    v-model.number="item.Jaar"
                    class="w-15"
                    placeholder="Jaar"
                    type="number"
                  />
                  <b-input
                    v-model.number="item.Aantal"
                    placeholder="Aantal"
                    class="w-15"
                    type="number"
                    min="0"
                  />
                  <b-input
                    v-model="item.Opmerking"
                    class="w-50"
                    placeholder="Opmerking"
                  />
                  <b-input-group-append>
                    <b-button
                      variant="danger"
                      class="pull-right"
                      size="sm"
                      @click="item.Aantal = -1"
                    >
                      <i class="fa fa-trash" />
                    </b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-list-group-item>
              <b-button
                @click="
                  unit.StoringenLaatsteJaren.push({
                    Aantal: 0,
                    Jaar: null,
                    Opmerking: null,
                  })
                "
              >
                <i class="fa fa-plus" />
              </b-button>
            </b-list-group>
          </b-card-body>
          <b-card-footer>
            <b-alert 
              variant="info" 
              show
            >
              Hierboven zijn alleen de storingen voor de afgelopen 3 jaar in te
              voeren!
            </b-alert>
          </b-card-footer>
        </b-card>
      </b-col>
      <b-col cols="4">
        <b-card no-body>
          <b-card-header>
            <b-card-title>Kaart</b-card-title>
          </b-card-header>
          
          <gmap-map 
            :center="unit.Position" 
            :zoom="14" 
            style="height: 400px"
          >
            <gmap-marker
              :position="unit.Position"
              :label="unit.Type"
              :title="unit.Adres"
            />
          </gmap-map>
          <b-card-footer>
            <b-form-group>
              <b-input-group>
                <b-input-group-text>
                  {{ `${unit.Adres}, ${unit.Postcode} ${unit.WijkPlaats}` }}
                </b-input-group-text>
                <b-input-group-addon>
                  <b-button @click="geocodedAddress">
                    Geolookup
                  </b-button>
                </b-input-group-addon>
                <b-input v-model.number="unit.Position.lat" />
                <b-input v-model.number="unit.Position.lng" />
              </b-input-group>
            </b-form-group>
          </b-card-footer>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import * as VueGoogleMaps from "vue2-google-maps";
import GmapCluster from "vue2-google-maps/dist/components/cluster"; // replace src with dist if you have Babel issues
import Vue from "vue";
import { serviceMixin } from "@/mixins/serviceMixin";
import { unitTabMixin } from "@/mixins/unitMixin";

import Geocoder from "@pderas/vue2-geocoder";

Vue.component("GmapCluster", GmapCluster);
Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyAhzyq_4d1zZ5Tei6SyD62UbPAd8xRy-0Q",
  },
});

Vue.use(Geocoder, {
    defaultCountryCode: null, // e.g. 'CA'
    defaultLanguage:    null, // e.g. 'en'
    defaultMode:        'address', // or 'lat-lng'
    googleMapsApiKey:  "AIzaSyAhzyq_4d1zZ5Tei6SyD62UbPAd8xRy-0Q"
});

export default {
  name: "TabDashboard",
  mixins: [serviceMixin,unitTabMixin],
  props: {
    unit: {
      type: Object,
      default: null
    },
  },
  data() {
    return {
      berichten: [],
      nieuwbericht: {
        subject: "",
        message: "",
      },
      busy: false,
    };
  },
  computed: {},
  watch: {
    unit: {
      handler: function () {
        this.getLogboek();
      },
      deep: true,
    },
  },
  mounted() {
    this.getLogboek();
  },
  methods: {
    getLogboek() {
      var vm = this;
      this.busy = true;
      this.get(this.unitLogBoekPath)
        .then(function (response) {
          vm.berichten = response.data.berichten;
        })
        .catch(function (error) {
          console.log(error);
        }).finally(() => {
          vm.busy = false;
        });
    },
    deleteMessage(bericht) {
      var index = this.berichten.indexOf(bericht);
      var vm = this;
      this.delete(this.unitLogBoekPath + bericht.Id)
        .then(function (response) {
          console.log(response.data);
          vm.berichten.splice(index, 1);
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    postMessage() {
      var vm = this;
      this.post(this.unitLogBoekPath, this.nieuwbericht)
        .then(function (response) {
          console.log(response.data);
          vm.berichten.unshift(response.data.bericht);
          vm.nieuwbericht = {
            subject: "",
            message: "",
          };
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    geocodedAddress() {
        Vue.$geocoder.send({
          address_line_1: this.unit.Adres,
          address_line_2: '',
          city:           this.unit.WijkPlaats,
          state:          this.unit.Regio,               // province also valid
          zip_code:       this.unit.Postcode,            // postal_code also valid
          country:        'Nederland'
      }, response => { 
        if (response.status == "OK") {
          this.unit.Position = response.results[0].geometry.location
          console.log(response.results[0].geometry.location) 
        } else {
          console.log(response)
        }
        
      });
    }
  },
};
</script>